<template>
    <!-- <form-dialog ref="form-saveas" title="新增" :data="data" width="80%" :visible.sync="visibleSync" :columns="formColumns" @confirm="SaveAs"></form-dialog> -->
    <cus-dialog ref="form-saveas" class="form-table-h500" :title="currentItem.title" :visible.sync="visibleSync" @confirm="SaveAs" :close-on-click-modal="false" width="80%" :okVisible="okVisible">
        <cus-form ref="form1" :columns="formColumns" :data="currentItem" @confirm="confirmForm"></cus-form>
        <el-row>
            <el-col class="padding-left20" :span="24">
                <label for="items" class="el-form-item__label"><span class="item-label">项 目</span></label>
                <div class="el-form-item__content align-left">
                    <el-button type="primary" size="small" plain @click="addParent"><i class="el-icon-plus"></i>添加</el-button>
                </div>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24" class="align-right">
                <TreeTable
                    :showSequence="false"
                    :selection="false"
                    ref="custtb"
                    :datalist="currentItem.datalist"
                    :tableHeight="this.screenHeight - 380"
                    @extrabutton-click="ExtraButtonClick"
                    :columns="columns"
                    :treeStyle="true"
                    :parentField="parentField"
                    :autoSelectParent="false"
                    :needEdit="true"
                    :rowDbClick="rowDbClick"
                    :genId="genId"
                    :idField="idField"
                >
                </TreeTable>
            </el-col>
        </el-row>
    </cus-dialog>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `EditTemplate`,
    props: {
        visible: { type: Boolean, default: () => false },
        data: { type: Object }
    },
    data() {
        return {
            currentItem: {
                id: 0,
                title: ``,
                name: ``,
                owner: ``,
                enum_charge_type: 1,
                region_type: 1,
                dic_ward_ids: [],
                datalist: [],
                enum_charge_category: 0, // 分类类型:1手术名称 2事件 3麻醉方式
                group_id: null, // 分组:参数设置中配置的分组
                charge_category_id: 0 // 选择分类项目Id
            },
            okVisible: false,
            permissions: [],
            enum_fee_type: 1, // 计费
            idField: `id_guid`,
            parentField: `parentid_guid`,
            charge_item_types: [],
            charge_item_type: ``,
            drug_section_id: 0,
            drug_section: {
                id: 0,
                name: undefined
            },
            additional_types: [],
            charge_template_group: this.$root.ChargeTemplateGroup && this.$root.ChargeTemplateGroup != `` && JSON.parse(this.$root.ChargeTemplateGroup) || [],
            onlySimpleWard: this.$root.OnlySimpleWard,
            chargeItemSelectConfig: this.$root.ChargeItemSelectConfig || 0,
            // 0-编码,1-规格,2-价格,3-单位,4-厂商,5-统一收费编码,6-医保类型,7-库存,8-描述
            chargeColumns: [
                { prop: `code`, label: `编码`, minWidth: 150, id: `0` },
                { prop: `spec`, label: `规格`, minWidth: 100, id: `1` },
                { prop: `price`, label: `价格`, minWidth: 80, id: `2` },
                { prop: `sell_unit`, label: `单位`, minWidth: 80, id: `3` },
                { prop: `firm`, label: `厂商`, minWidth: 120, id: `4` },
                { prop: `uni_charge_code`, label: `收费编码`, minWidth: 100, id: `5` },
                { prop: `medical_type`, label: `医保`, minWidth: 80, id: `6` },
                { prop: `inventory`, label: `库存`, minWidth: 80, id: `7` },
                { prop: `description`, label: `描述`, minWidth: 100, id: `8` }
            ]
        }
    },
    mounted() {
        this.loadConfigs().then(() => {
            this.loadChargeItemTypes()
            this.loadPermissions()
            this.loadAdditionalTypes()
        })
    },
    computed: {
        ...mapGetters([`ward_auth`, `currentUser`, `active_ward`, `sys_enums`, `screenHeight`, `section_auth`]),
        enumDrugType() {
            return this[`sys_enums`]
        },
        wardOptions() {
            let wards = null
            // ACIS-26427 麻烦啊，当 手术申请 source_hospital_ward_id 不为空,需要根据 来源院区过滤 手术区/复苏区
            if (this.surgeryInfo && this.surgeryInfo.source_hospital_ward_id) {
                wards = _.filter(this.ward_auth, ward => ward.groupId == this.surgeryInfo.source_hospital_ward_id)
            } else {
                wards = _.cloneDeep(this.ward_auth)
                // 是否开启单院区过滤
                if (!this.surgeryId && this.onlySimpleWard == `1`) {
                    // 从科室菜单-用药模版来的且 开启单院区过滤,根据右上角单院区来过滤
                    wards = _.filter(wards, ward => ward.groupId == this.active_ward.groupId)
                }
            }
            return wards
        },
        visibleSync: {
            get: function() {
                return this.visible
            },
            set: function(newval) {
                this.$emit(`update:visible`, newval)
            }
        },
        regionTypeOption() {
            let r = []
            if (this.onlySimpleWard != `1`) {
                r.push({ label: `个人`, value: 1 })
            }
            r.push({ label: `区域`, value: 2 })
            console.log(`111111111`, r)
            return r
        },
        formColumns() {
            let nameColIndex = this.charge_template_group.length > 0 ? 2 : 1
            let regionTypeColIndex = this.charge_template_group.length > 0 ? 4 : 3
            let cols = [
                {
                    type: `select`,
                    prop: `enum_charge_category`,
                    label: `分类`,
                    width: `100`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    colspan: 3,
                    options: [{ label: `--无--`, value: 0 }, { label: `手术名称`, value: 1 }, { label: `事件`, value: 2 }, { label: `麻醉方式`, value: 3 }],
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    change: (that, { row, index }) => {
                        // ACIS-23619【计费】计费模板增加分类字段，用于维护手术名称、事件、麻醉方式能自动提取到计费
                        if (row.enum_charge_category == `1`) {
                            row.name = ``
                            cols[nameColIndex].type = `remoteselect`
                            cols[nameColIndex].options = `/api/AcisSystem/Surgery/Search`
                            cols[nameColIndex]._remoteSelectValue = ``
                        } else if (row.enum_charge_category == `2`) {
                            row.name = ``
                            cols[nameColIndex].type = `remoteselect`
                            cols[nameColIndex].options = `/api/AcisSystem/Event/SearchEvent`
                            cols[nameColIndex]._remoteSelectValue = ``
                        } else if (row.enum_charge_category == `3`) {
                            row.name = ``
                            cols[nameColIndex].type = `remoteselect`
                            cols[nameColIndex].options = `/api/AcisSystem/AnaesthesiaMethod/Search`
                            cols[nameColIndex]._remoteSelectValue = ``
                        } else {
                            row.name = ``
                            cols[nameColIndex].type = `string`
                            cols[nameColIndex].options = null
                        }
                    }
                },
                {
                    type: `string`,
                    prop: `name`,
                    label: `名称`,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    colspan: 6,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                }, {
                    type: `select`,
                    prop: `enum_charge_type`,
                    label: `类型`,
                    width: `100`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    colspan: 4,
                    options: [{ value: 0, label: `手术计费` }, { value: 1, label: `麻醉计费` }],
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `radio`,
                    prop: `region_type`,
                    label: `可用范围`,
                    width: `100`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    colspan: 5,
                    options: this.regionTypeOption,
                    default: 0,
                    change: (that, { row }) => {
                        if (row.region_type == 2) {
                            if (row.dic_ward_ids.length == 0 || !row.dic_ward_ids) {
                                var ids = []
                                ids.push(this.active_ward.value)
                                row.dic_ward_ids = ids
                            }
                        }
                    }
                }
            ]
            if (this.charge_template_group.length > 0) {
                cols.unshift({
                    type: `select`,
                    prop: `group_id`,
                    label: `分组`,
                    width: `100`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    colspan: 3,
                    options: this.charge_template_group
                }) // 插入开头
            }

            let editpermission = _.find(this.permissions, x => x.permission == `tmp:area_edit`)
            let readpermission = _.find(this.permissions, x => x.permission == `tmp:area_read`)
            let allpermission = _.find(this.permissions, x => x.permission == `tmp:alltmp`)
            if (!this.currentItem.id || this.currentItem.id == 0) {
                this.okVisible = true
                if ((readpermission && editpermission) || allpermission) {
                    cols[regionTypeColIndex].options = this.regionTypeOption
                    cols.push({
                        type: `groupmultiselect`,
                        prop: `dic_ward_ids`,
                        label: `可用区域`,
                        isListable: true,
                        isEditable: true,
                        isCreatable: true,
                        colspan: 6,
                        options: this.wardOptions,
                        readonly: function(that, { row, column, area }) {
                            if (area == `form`) {
                                return row.region_type === 1
                            } else {
                                return true
                            }
                        }
                    })
                } else {
                    cols[regionTypeColIndex].options = _.filter(this.regionTypeOption, x => x.label == `个人` || x.value == 1)
                }
            } else {
                cols.push({
                    type: `groupmultiselect`,
                    prop: `dic_ward_ids`,
                    label: `可用区域`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true,
                    colspan: 6,
                    options: this.wardOptions,
                    readonly: function(that, { row, column, area }) {
                        if (area == `form`) {
                            return row.region_type === 1
                        } else {
                            return true
                        }
                    }
                })
                let user = (this.currentUser && this.currentUser.username) || `--`
                if (editpermission || (this.currentItem.region_type === 1 && this.currentItem.owner == user) || allpermission) {
                    this.okVisible = true
                } else {
                    this.okVisible = false
                }
                // ACIS-23619【计费】计费模板增加分类字段，用于维护手术名称、事件、麻醉方式能自动提取到计费
                if (this.currentItem.enum_charge_category == `1`) {
                    cols[nameColIndex].type = `remoteselect`
                    cols[nameColIndex].options = `/api/AcisSystem/Surgery/Search`
                } else if (this.currentItem.enum_charge_category == `2`) {
                    cols[nameColIndex].type = `remoteselect`
                    cols[nameColIndex].options = `/api/AcisSystem/Event/SearchEvent`
                } else if (this.currentItem.enum_charge_category == `3`) {
                    cols[nameColIndex].type = `remoteselect`
                    cols[nameColIndex].options = `/api/AcisSystem/AnaesthesiaMethod/Search`
                } else {
                    cols[nameColIndex].type = `string`
                    cols[nameColIndex].options = null
                }
            }
            return cols
        },
        columns() {
            let me = this
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `序号`,
                    isKey: true,
                    isListable: false
                }, {
                    type: `number`,
                    prop: `display_order`,
                    label: `排序`,
                    width: 80,
                    isListable: true,
                    readonly: false,
                    default: 1
                },
                {
                    type: this.chargeItemSelectConfig == 1 ? `tableselect` : `remoteselect`,
                    prop: `dic_chrg_item`,
                    label: `项目名称`,
                    isListable: true,
                    readonly: false,
                    width: 240,
                    options: (that, { row }) => {
                        return q => {
                            q.chargeSourceHospitalWardId = (me.onlySimpleWard == `1`) ? me.active_ward.groupId : 0
                            return this.loadChargeItemList(q, row)
                        }
                    },
                    selectColumn: this.chargeColumns,
                    change: (that, { row, index }) => {
                        if (row.dic_chrg_item && row.dic_chrg_item.value) {
                            let req = this.myaxios.get(`/api/AcisSystem/ChargeItem/Get/${row.dic_chrg_item.value}`)
                            let req1 = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=DefaultDrugSection`)
                            this.myaxios.all(req, req1).then(([data, data1]) => {
                                let id = (data.dic_chrg_item_type_id == 1 || data.is_drug_type) ? this.drug_section.id : null
                                if (!this.isParent(row) &&
                                    (!data.additional_type || data.dic_chrg_item_type_id != 7)) {
                                    this.$set(row, `dic_chrg_item`, {})
                                    this.$message.error(`该项目加收类型为空或项目类型不是手术，请重新选择`)
                                    return
                                }

                                if (!_.has(row, `amount`) || !row.amount) {
                                    this.$set(row, `amount`, 1)
                                }
                                this.$set(row, `additional_type`, data.additional_type) // 加收类型
                                this.$set(row, `display_order`, index + 1) // 排序
                                this.$set(row, `spec`, data.spec) // 规格
                                this.$set(row, `sell_unit`, data.sell_unit) // 计价单位
                                this.$set(row, `price`, data.price) // 单价
                                this.$set(row, `dic_chrg_item_type_id`, data.dic_chrg_item_type_id) // 项目类型id
                                this.$set(row, `dic_chrg_item_type`, this.getChargeItemTypeName(data.dic_chrg_item_type_id)) // 项目类型名称
                                this.$set(row, `execute_dept`, id)
                                this.$set(row, `charg_rate`, data.charg_rate)
                            })
                        } else {
                            if (!_.has(row, `amount`) || !row.amount) {
                                this.$set(row, `amount`, 1)
                            }
                            this.$set(row, `additional_type`, ``)
                            this.$set(row, `spec`, ``)
                            this.$set(row, `firm`, ``)
                            this.$set(row, `sell_unit`, ``)
                            this.$set(row, `price`, ``)
                            this.$set(row, `dic_chrg_item_type`, ``)
                            this.$set(row, `charg_rate`, ``)
                        }
                    }
                },
                {
                    type: `select`,
                    prop: `additional_type`,
                    label: `加收类型`,
                    width: 180,
                    isListable: true,
                    readonly: (that, { row }) => {
                        return row.dic_chrg_item_type != `手术`
                    },
                    options: _.map(me.additional_types, d => {
                        return {
                            label: d.additional_type,
                            value: d.additional_type
                        }
                    }),
                    change: (that, { row, index }) => {
                        if (row.additional_type && row.additional_type.length > 0) {
                            let additype = _.find(me.additional_types, x => x.additional_type == row.additional_type)
                            if (!additype) {
                                me.$message.error(`未找到该加收类型，请尝试刷新后重试`)
                                return
                            }
                            if (!additype.charg_rate) {
                                me.$message.error(`该加收类型未配置加收比例，系统默认为1`)
                                additype.charg_rate = 1
                            }
                            this.$set(row, `charg_rate`, additype.charg_rate) // 默认计费
                        } else {
                            this.$set(row, `charg_rate`, 1)
                        }
                    }
                },
                {
                    type: `string`,
                    prop: `spec`,
                    label: `规格`,
                    width: 140,
                    isListable: true
                },
                {
                    type: `float`,
                    prop: `amount`,
                    label: `计费数量`,
                    decimal_places: 2,
                    width: 75,
                    isListable: true,
                    readonly: false,
                    default: 1,
                    change: (that, { row }) => {
                        if (row.amount && row.amount < 0) { row.amount = 0 }
                    }
                },
                {
                    type: `string`,
                    prop: `sell_unit`,
                    label: `计价单位`,
                    width: 75,
                    isListable: true
                },
                {
                    type: `float`,
                    prop: `charg_rate`,
                    label: `比例`,
                    width: `80`,
                    format: function(row) {
                        if (row.charg_rate == null || row.charg_rate == 0) { return `` } else { return (row.charg_rate * 100).toFixed(2) + `%` }
                    },
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `price`,
                    label: `单价(元)`,
                    width: 75,
                    isListable: true,
                    format: function(row) {
                        if (row.isRoot == false && row.charg_rate) {
                            return ``
                        } else {
                            return row.price
                        }
                    }
                },
                {
                    type: `string`,
                    prop: `total_price`,
                    label: `计费金额`,
                    width: 80,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `dic_chrg_item_type`,
                    label: `项目类型`,
                    width: 80,
                    isListable: true
                },
                // {
                //     type: `select`,
                //     prop: `execute_dept`,
                //     label: `执行科室`,
                //     width: 100,
                //     // options: this[`section_auth`],
                //     readonly: false,
                //     options: (that, { row }) => {
                //         if (row.dic_chrg_item_type_id == 1) {
                //             return this.drugSections
                //         } else {
                //             return this.section_auth
                //         }
                //     }
                // },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: `操作`,
                    options: (that, { row }) => {
                        var btns = []
                        if (this.isMainOperation(row)) {
                            btns.push({ label: `新增`, type: `primary`, emit: `addChild`, permission: `default`, class: `is-plain` })
                        }
                        btns.push({ label: ``, type: `primary`, emit: `goUp`, permission: `default`, class: `el-icon-top` })
                        btns.push({ label: ``, type: `primary`, emit: `goDown`, permission: `default`, class: `el-icon-bottom` })
                        btns.push({ label: `删除`, type: `danger`, emit: `removeItem`, permission: `default`, class: `is-plain` })
                        return btns
                    }
                }
            ]
        },
        OperationTotalPrice() {
            let calcList = _.filter(this.currentItem.datalist, data => {
                return this.isMainOperation(data)
            })
            return _.sumBy(calcList, d => this.enum_fee_type * d.total_price)
        },
        drugSections() {
            let all = this[`section_auth`]
            if (all && all.length > 0) {
                var yaofang = []
                let other = []
                for (let item of all) {
                    if (!item.disabled) {
                        if (item.label.indexOf(`药房`) >= 0) {
                            yaofang.push(item)
                        } else {
                            other.push(item)
                        }
                    }
                }
                return yaofang.concat(other)
            }
            return []
        }
    },
    methods: {
        loadAdditionalTypes() {
            return new Promise((resolve, reject) => {
                this.myaxios.get(`/api/AcisSystem/AdditionalType/Get`)
                    .then(data => {
                        this.additional_types = data
                        resolve(this.additional_types)
                    })
            })
        },
        loadPermissions() {
            let req = this.myaxios.get(`/api/AcisSystem/Authorization/GetPermissions`) // 获取当前用户的权限
            req.then(data => {
                this.permissions = data
            }).catch(e => {
            })
        },
        loadChargeItemTypes() {
            return new Promise((resolve, reject) => {
                this.myaxios.get(`/api/AcisSystem/ChargeItem/SearchType`)
                    .then(data => {
                        this.charge_item_types = data
                        resolve(this.charge_item_types)
                    })
            })
        },
        getChargeItemTypeName(id) {
            let item = _.find(this.charge_item_types, x => x.value == id)
            return item.label || ``
        },
        ExtraButtonClick({ emit, row, index }) {
            if (emit == `addChild`) {
                this.addChild(row)
            } else if (emit == `removeItem`) {
                this.removeItem(row)
            } else if (emit == `goUp`) {
                if (index > 0) {
                    this.goUp(row, index)
                }
            } else if (emit == `goDown`) {
                this.goDown(row, index)
            }
        },
        rowDbClick(row, column, event) {
            if (column.label == `操作` || column.type == `selection` || row.rowStatus > 0) {
                return
            }
            if (event.offsetX < 20 && column.label == `项目名称`) {
                return
            }
            row.rowStatus = 2
        },
        addParent() {
            let pa = this.$refs.custtb.addParent()
            if (pa) {
                this.addTotalPriceProp(pa)
            }
        },
        addChild(row) {
            let ch = this.$refs.custtb.addChild(row)
            if (ch) {
                this.addTotalPriceProp(ch)
            }
        },
        goUp(row, Index) {
            this.$refs.custtb.goUp(row, Index)
        },
        goDown(row, Index) {
            this.$refs.custtb.goDown(row, Index)
        },
        removeItem(row) {
            this.$refs.custtb.deleteRow(row)
        },
        loadTempItems() {
            this.currentItem.id = this.data.id
            this.currentItem.title = this.data.title
            this.currentItem.name = this.data.name
            this.currentItem.owner = this.data.owner
            this.currentItem.enum_charge_type = this.data.enum_charge_type
            this.currentItem.region_type = this.data.region_type
            if (this.data.region_type == 2 && this.data.dic_ward_ids.length == 0) {
                var ids = []
                ids.push(this.active_ward.value)
                this.currentItem.dic_ward_ids = ids
            } else {
                this.currentItem.dic_ward_ids = this.data.dic_ward_ids
            }
            this.currentItem.enum_charge_category = this.data.enum_charge_category
            this.currentItem.group_id = this.data.group_id
            this.currentItem.charge_category_id = this.data.charge_category_id

            let mainOperationRows = []
            let mainAdditionRows = []
            let childRows = []
            let otherRows = []
            let tmp = _.map(this.data.items, (r, index) => {
                let d = { ...r }
                this.addTotalPriceProp(d)
                if (this.isMainOperation(d)) {
                    mainOperationRows.push(d)
                } else if (this.isMainAddition(d)) {
                    mainAdditionRows.push(d)
                } else if (this.isChildAddition(d)) {
                    childRows.push(d)
                } else { otherRows.push(d) }
                return d
            })
            tmp = mainOperationRows.concat(mainAdditionRows, childRows, otherRows)
            let that = this
            this.$nextTick(() => {
                that.currentItem.datalist = that.$refs.custtb.toTree(tmp)
            })
        },
        saveOne(row) {
            let chargeCategoryId = 0
            let groupId = null
            if (row.id > 0) {
                return new Promise((resolve, reject) => {
                    if (row.group_id) {
                        groupId = row.group_id
                    }
                    if (row.charge_category_id && !row.name.value) {
                        chargeCategoryId = row.charge_category_id
                    } else if (row.name.value) {
                        chargeCategoryId = row.name.value
                    }
                    let req = this.myaxios.put(`api/AcisSystem/ChargeTemplate/Put`, {
                        id: row.id,
                        // name: row.name,
                        name: row.enum_charge_category == `0` ? row.name : row.name.label,
                        enum_charge_category: row.enum_charge_category,
                        group_id: groupId,
                        enum_charge_type: row.enum_charge_type,
                        charge_category_id: chargeCategoryId,
                        items: row.datalist.map(sOne => {
                            return {
                                id_guid: sOne.id_guid,
                                parentid_guid: sOne.parentid_guid,
                                additional_type: sOne.additional_type,
                                charg_rate: sOne.charg_rate,
                                total_price: sOne.total_price,
                                item_name: sOne.dic_chrg_item.label,
                                dic_chrg_item_id: sOne.dic_chrg_item.value,
                                amount: sOne.amount,
                                display_order: sOne.display_order,
                                dic_section_id: sOne.execute_dept
                            }
                        }),
                        regions:
                        row.region_type == 1
                            ? [{ owner: (this.data.owner || this.currentUser.username) }]
                            : row.dic_ward_ids.map(d => {
                                return {
                                    // "sys_charge_template_id": 0,
                                    dic_operating_ward_id: _.startsWith(d, `ow_`) ? d.substr(3) : 0,
                                    dic_recovery_ward_id: _.startsWith(d, `rw_`) ? d.substr(3) : 0
                                }
                            })
                    })
                    req.then(data => {
                        resolve(data)
                    }).catch(e => reject(e))
                })
            } else {
                // this.createOne(row)

                return new Promise((resolve, reject) => {
                    if (row.group_id) {
                        groupId = row.group_id
                    }
                    if (row.enum_charge_category != `0` && row.name.value) {
                        chargeCategoryId = row.name.value
                    }
                    let req = this.myaxios.post(`api/AcisSystem/ChargeTemplate/Post`, {
                        // name: row.name,
                        name: row.enum_charge_category == `0` ? row.name : row.name.label,
                        enum_charge_category: row.enum_charge_category,
                        charge_category_id: chargeCategoryId,
                        group_id: groupId,
                        enum_charge_type: row.enum_charge_type,
                        items: row.datalist.map(sOne => {
                            return {
                                id_guid: sOne.id_guid,
                                parentid_guid: sOne.parentid_guid,
                                additional_type: sOne.additional_type,
                                charg_rate: sOne.charg_rate,
                                total_price: sOne.total_price,
                                item_name: sOne.dic_chrg_item.label,
                                dic_chrg_item_id: sOne.dic_chrg_item.value,
                                amount: sOne.amount,
                                display_order: sOne.display_order,
                                dic_section_id: sOne.execute_dept
                            }
                        }),
                        regions:
                        row.region_type == 1
                            ? [{ owner: (this.data.owner || this.currentUser.username) }]
                            : row.dic_ward_ids.map(d => {
                                return {
                                    // "sys_charge_template_id": 0,
                                    dic_operating_ward_id: _.startsWith(d, `ow_`) ? d.substr(3) : 0,
                                    dic_recovery_ward_id: _.startsWith(d, `rw_`) ? d.substr(3) : 0
                                }
                            })
                    })
                    req.then(data => {
                        resolve(data)
                    }).catch(e => reject(e))
                })
            }
        },
        SaveAs() {
            this.$refs[`form1`].confirm()
        },
        confirmForm(row) {
            try {
                if (row.region_type == 2 && ((row.dic_ward_ids.__ob__ && row.dic_ward_ids.__ob__.value.length <= 0) || !row.dic_ward_ids)) {
                    this.$message.error(`请选择区域！`)
                    return
                }
                var alldata = this.getAllData()
                var savedata = _.filter(alldata, d => d.dic_chrg_item && d.dic_chrg_item.value)
                if (savedata.length === 0) {
                    this.$message.error(`模板项目为空，请完善！`)
                    return
                }
                let noneExecuteDept = []
                let noneRateOrPriceArr = []
                savedata.forEach(d => {
                    if (!d.charg_rate && (d.price || 0) == 0) {
                        d.price = 0
                        noneRateOrPriceArr.push(d)
                    } else if (!d.execute_dept || d.execute_dept == 0) {
                        noneExecuteDept.push(d)
                    } else {
                        this.$set(d, `class_name`, ``)
                    }
                })

                // if (noneExecuteDept.length > 0) {
                //     this.$message.error(`请选择执行部门！`)
                //     noneExecuteDept.forEach(d => {
                //         this.$set(d, `class_name`, `fontred`)
                //     })
                //     return
                // }

                if (noneRateOrPriceArr.length > 0) {
                    if (noneRateOrPriceArr.length > 0) {
                        noneRateOrPriceArr.forEach(d => {
                            this.$set(d, `class_name`, `fontred`)
                        })
                    }
                    this.$confirm(`存在（单价，比例）为空的数据<br/>是否确认保存?`, `提示`, {
                        dangerouslyUseHTMLString: true,
                        confirmButtonText: `确定`,
                        cancelButtonText: `取消`,
                        type: `warning`
                    }).then(() => {
                        row.datalist = savedata
                        this.saveOne(row).then(data => {
                            this.$emit(`save-success`)
                            this.visibleSync = false
                        })
                    }).catch(() => {
                        if (noneRateOrPriceArr.length > 0) {
                            noneRateOrPriceArr.forEach(d => {
                                this.$set(d, `class_name`, `fontred`)
                            })
                        }
                    })
                } else {
                    row.datalist = savedata
                    this.saveOne(row).then(data => {
                        this.$emit(`save-success`)
                        this.visibleSync = false
                    })
                }
            } catch (e) {
                console.log(e)
            }
        },
        addTotalPriceProp(data) {
            var that = this
            var pField = that.parentField
            Object.defineProperty(data, `total_price`, {
                get: function() {
                    try {
                        let amount = parseFloat(this.amount)
                        let rate = parseFloat(this.charg_rate)
                        let unitPrice = parseFloat(this.price)
                        let result = 0
                        if (!amount || amount <= 0) return ``
                        if (that.isMainOperation(this)) {
                            if (rate) {
                                result = (amount * rate * unitPrice).toFixed(2)
                            } else {
                                result = (amount * unitPrice).toFixed(2)
                            }
                        } else if (that.isChildAddition(this)) {
                            if (!rate) {
                                result = (amount * unitPrice).toFixed(2)
                            } else {
                                let parent = _.find(that.currentItem.datalist, x => x[that.idField] == this[pField])
                                if (parent) {
                                    result = (amount * rate * parent.total_price).toFixed(2)
                                } else {
                                    result = NaN
                                }
                            }
                        } else if (that.isMainAddition(this)) {
                            if (!rate) {
                                result = (amount * unitPrice).toFixed(2)
                            } else {
                                result = (amount * rate * that.OperationTotalPrice).toFixed(2)
                            }
                        } else {
                            if (!rate) {
                                result = (amount * unitPrice).toFixed(2)
                            } else {
                                result = (amount * rate * unitPrice).toFixed(2)
                            }
                        }
                        if (isNaN(result)) { return `` }
                        return result
                    } catch (e) {
                        console.log(e)
                    }
                }
            })
        },
        isParent(data) {
            return !data[this.parentField] || data[this.parentField] == 0
        },
        isMainOperation(data) {
            return this.isParent(data) &&
                   data.level == 1 &&
                   data.dic_chrg_item_type_id == 7
        },
        isMainAddition(data) {
            let r = this.isParent(data) &&
                    data.level == 2 &&
                    data.dic_chrg_item_type_id == 7
            return r
        },
        isChildAddition(data) {
            return !this.isParent(data) &&
                   data.level == 2 &&
                   data.dic_chrg_item_type_id == 7
        },
        getAllData() {
            var arr = []
            this.currentItem.datalist.forEach(x => {
                arr.push(x)
                if (x.children && x.children.length > 0) {
                    x.children.forEach(y => {
                        arr.push(y)
                    })
                }
            })
            return arr
        },
        createOne(row, currentItem) {
            return new Promise((resolve, reject) => {
                let req = this.myaxios.post(`api/AcisSystem/ChargeTemplate/Post`, {
                    name: currentItem.name,
                    enum_charge_type: currentItem.enum_charge_type,
                    items: [{
                        additional_type: row.additional_type,
                        charg_rate: row.charg_rate,
                        total_price: row.total_price,
                        item_name: row.dic_chrg_item.label,
                        dic_chrg_item_id: row.dic_chrg_item.value,
                        amount: row.amount,
                        display_order: row.display_order,
                        dic_section_id: row.execute_dept
                    }],
                    regions:
                        currentItem.region_type == 1
                            ? [{ owner: (this.data.owner || this.currentUser.username) }]
                            : currentItem.dic_ward_ids.map(d => {
                                return {
                                    // "sys_charge_template_id": 0,
                                    dic_operating_ward_id: _.startsWith(d, `ow_`) ? d.substr(3) : 0,
                                    dic_recovery_ward_id: _.startsWith(d, `rw_`) ? d.substr(3) : 0
                                }
                            })
                })
                req.then(data => {
                    resolve(data)
                }).catch(e => reject(e))
            })
        },
        updateOne(row, currentItem) {
            return new Promise((resolve, reject) => {
                let req = this.myaxios.put(`api/AcisSystem/ChargeTemplate/Put`, {
                    id: currentItem.id,
                    name: currentItem.name,
                    enum_charge_type: currentItem.enum_charge_type,
                    items: [{
                        additional_type: row.additional_type,
                        charg_rate: row.charg_rate,
                        total_price: row.total_price,
                        item_name: row.dic_chrg_item.label,
                        dic_chrg_item_id: row.dic_chrg_item.value,
                        amount: row.amount,
                        display_order: row.display_order,
                        dic_section_id: row.execute_dept
                    }],
                    regions:
                        currentItem.region_type == 1
                            ? [{ owner: (this.data.owner || this.currentUser.username) }]
                            : currentItem.dic_ward_ids.map(d => {
                                return {
                                    // "sys_charge_template_id": 0,
                                    dic_operating_ward_id: _.startsWith(d, `ow_`) ? d.substr(3) : 0,
                                    dic_recovery_ward_id: _.startsWith(d, `rw_`) ? d.substr(3) : 0
                                }
                            })
                })
                req.then(data => {
                    resolve(data)
                }).catch(e => reject(e))
            })
        },
        loadChargeItemList(q, row) {
            let that = this
            let itemTypeId = 0
            let level = 0
            if (!this.isParent(row)) {
                level = 2
                itemTypeId = 7
            }
            return new Promise(resolve => {
                let req = this.myaxios.get(`api/AcisSystem/ChargeItem/SearchForChargeNewProc?keyword=${q && q.keyword}&level=${level}&itemTypeId=${itemTypeId}&chargeSourceHospitalWardId=${q && q.chargeSourceHospitalWardId}`)
                req.then(data => {
                    let result = []
                    if (data) {
                        data.forEach(d => {
                            let codes = []
                            for (let item of that.item_configs) {
                                if (item === `0`) codes.push(d.code)
                                if (item === `1`) codes.push(d.spec || `--`)
                                if (item === `2`) codes.push(d.price || `--`)
                                if (item === `3`) codes.push(d.sell_unit || `--`)
                                if (item === `4`) codes.push(d.firm || `--`)
                                if (item === `5`) codes.push(d.uni_charge_code || `--`)
                                if (item === `6`) codes.push(d.medical_type || `--`)
                                if (item === `7`) codes.push(`库存:${d.inventory || `--`}`)
                                if (item === `8`) codes.push(d.description || `--`)
                            }
                            let obj = {
                                ...d,
                                value: d.id,
                                label: d.name,
                                abbr: d.abbr,
                                code: codes.join(`/`)
                            }
                            result.push(obj)
                        })
                    }
                    resolve(result)
                })
            })
        },
        loadConfigs() {
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/Config/Get`)
                let req1 = this.myaxios.get(`/api/AcisSystem/Section/Get`)
                this.myaxios.all(req, req1).then(([data, data1]) => {
                    let info = _.filter(data, { key: `DefaultDrugSection` })[0] && _.filter(data, { key: `DefaultDrugSection` })[0].value
                    let config = _.filter(data, { key: `ChargeItemCodeConfig` })[0] && _.filter(data, { key: `ChargeItemCodeConfig` })[0].value
                    this.item_configs = config.split(`|`)
                    let code = info.split(`|`)[0]
                    let name = info.split(`|`)[1]
                    this.drug_section.id =
                        (_.filter(data1, d => {
                            return d.code == code && d.name == name
                        })[0] &&
                            _.filter(data1, d => {
                                return d.code == code && d.name == name
                            })[0].id) ||
                        0
                    this.drug_section.name =
                        (_.filter(data1, d => {
                            return d.code == code && d.name == name
                        })[0] &&
                            _.filter(data1, d => {
                                return d.code == code && d.name == name
                            })[0].name) ||
                        undefined
                    this.setChargeColumns()
                    resolve(this.drug_section)
                })
            })
        },
        setChargeColumns() {
            let that = this
            let resultColumns = [
                { prop: `name`, label: `项目名称`, minWidth: 250, fixed: `left` }
            ]
            that.item_configs.forEach(item => {
                let codeInfo = _.find(that.chargeColumns, { id: item })
                if (codeInfo) {
                    resultColumns.push(codeInfo)
                }
            })
            console.log(resultColumns)
            this.chargeColumns = resultColumns
        },
        genId() {
            var d = new Date().getTime()
            var uuid = `xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx`.replace(/[xy]/g, function(c) {
                var r = (d + Math.random() * 16) % 16 | 0
                d = Math.floor(d / 16)
                return (c == `x` ? r : (r & 0x3) | 0x8).toString(16)
            })
            return uuid
        }

    },
    watch: {
        visibleSync: function() {
            if (this.visibleSync) { this.loadTempItems() }
        }
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Charge/Anesthesia/EditTemplate.vue